// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a-no-data[data-v-d1e17308]{justify-content:center;align-items:center;flex-direction:column;display:flex;font-size:14px;line-height:2;color:#111}.a-no-data__text[data-v-d1e17308]{text-align:center;white-space:pre-wrap}.a-no-data__item[data-v-d1e17308]{margin-top:14px}", ""]);
// Exports
module.exports = exports;
